import { MouseEvent } from "react"
import { Link, LinkProps } from "react-router-dom"
import { useViewTransition } from "../hooks/useViewTransition"

export function ViewTransitionLink({ to, children, onClick, ...props }: LinkProps) {
  const navigateWithTransition = useViewTransition()

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Call the original onClick if provided
    if (onClick) {
      onClick(e)
    }

    // If default wasn't prevented, handle the navigation with transition
    if (!e.defaultPrevented) {
      e.preventDefault()
      navigateWithTransition(to)
    }
  }

  return (
    <Link to={to} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}
